module.exports = __webpack_public_path__ + "static/media/add_circle_outline-24px.7c1b9060.svg";